// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","461":"cc1ef4e7","890":"component---src-templates-page-template-js"}[chunkId] || chunkId) + "-" + {"125":"201177d6129c3a87ee99","461":"fb239fd6ceb1583a84f0","522":"7b842c76ce25d61ff0e4","890":"5a34a7a9e08b2ed112da"}[chunkId] + ".js";
};